import {useIntl} from 'react-intl'

export default function useSearchReviewsFields({
    form: {
        control,
        formState: {errors}
    },
    prefix = ''
}) {
    const {formatMessage} = useIntl()

    const fields = {
        searchTerm: {
            name: `${prefix}searchTerm`,
            placeholder: formatMessage({
                defaultMessage: 'Enter Search Terms',
                id: 'use_search_reviews_fields.enter_search_terms'
            }),
            type: 'text',
            defaultValue: '',
            error: errors[`${prefix}searchTerm`],
            inputProps: {
                autoComplete: 'off',
                variant: 'flushed'
            },
            control,
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter search terms.',
                    id: 'use_search_reviews_fields.error.required_search_terms'
                }),
                validate: {
                    hasMinChars: (val) =>
                        val.length >= 3 ||
                        formatMessage({
                            defaultMessage: 'Search field must contain at least 3 characters.',
                            id: 'use_search_reviews_fields.error.minimum_characters'
                        }),
                    hasMaxChars: (val) =>
                        val.length <= 30 ||
                        formatMessage({
                            defaultMessage: 'Search field must contain at most 30 characters.',
                            id: 'use_search_reviews_fields.error.maximum_characters'
                        })
                }
            }
        }
    }

    return fields
}
